import React, {useEffect, useState} from "react";
import Modal from "../modal/Modal";

function MemoExpandModal({
    open,
    onOpenChange,
    title = "메모",
    content,
    readOnly = false,
    onSave,
    meta,
}) {
    const [local, setLocal] = useState(content ?? "");

    useEffect(() => {
        if (open) {
            setLocal(content ?? "");
        }
    }, [content, open]);

    const handleSave = () => {
        onSave?.(local);
        onOpenChange(false);
    };

    return (
        <Modal
            isOpen={open}
            onClose={() => onOpenChange(false)}
            className="memo-expand-modal-overlay"
        >
            <div className="memo-expand-panel">
                <div className="memo-expand-head">
                    <h2 className="memo-expand-title">{title}</h2>
                    {meta && (
                        <p className="memo-expand-meta">
                            {meta.author}
                            {meta.date ? ` · ${meta.date}` : ""}
                        </p>
                    )}
                </div>
                <div className="memo-expand-body-wrap">
                    {readOnly ? (
                        <div className="memo-expand-readonly">{content}</div>
                    ) : (
                        <textarea
                            className="memo-expand-textarea"
                            value={local}
                            onChange={(e) => setLocal(e.target.value)}
                            autoFocus
                            placeholder="메모 내용을 입력하세요"
                        />
                    )}
                </div>
                <div className="memo-expand-foot">
                    <button
                        type="button"
                        className="memo-btn memo-btn--ghost"
                        onClick={() => onOpenChange(false)}
                    >
                        닫기
                    </button>
                    {!readOnly && (
                        <button
                            type="button"
                            className="memo-btn memo-btn--primary"
                            onClick={handleSave}
                            disabled={!local.trim()}
                        >
                            저장
                        </button>
                    )}
                </div>
            </div>
        </Modal>
    );
}

export function isLongMemo(content) {
    if (!content) return false;
    const text = String(content);
    return text.length > 120 || text.split("\n").length > 4;
}

export default MemoExpandModal;
